// App.jsx
import React from "react";
import ProgramFilter from "./ProgramFilter.jsx";

const App = ({properties}) => {
    return (
        <div>
            <ProgramFilter properties={properties} />
        </div>
    );
};

export default App;
